import { Card, Row, Col, Button } from "antd";

export default function StatsCards({
  transactions,
  resetBalance,
  openIncome,
  openExpense,
}) {
  // Calculate totals safely
  const income = transactions
    .filter((t) => t.type?.toLowerCase() === "income")
    .reduce((acc, curr) => acc + Number(curr.amount || 0), 0);

  const expense = transactions
    .filter((t) => t.type?.toLowerCase() === "expense")
    .reduce((acc, curr) => acc + Number(curr.amount || 0), 0);

  const balance = income - expense;

  return (
    <div style={{ padding: "20px" }}>
      <Row gutter={[16, 16]}>
        {/* Current Balance */}
        <Col xs={24} md={8}>
          <Card title="Current Balance">
            <h2>₹{balance}</h2>

            <Button
              type="primary"
              block
              onClick={resetBalance}
              style={{ marginTop: "10px" }}
            >
              Reset Balance
            </Button>
          </Card>
        </Col>

        {/* Total Income */}
        <Col xs={24} md={8}>
          <Card title="Total Income">
            <h2>₹{income}</h2>

            <Button
              type="primary"
              block
              onClick={openIncome}
              style={{ marginTop: "10px" }}
            >
              Add Income
            </Button>
          </Card>
        </Col>

        {/* Total Expenses */}
        <Col xs={24} md={8}>
          <Card title="Total Expenses">
            <h2>₹{expense}</h2>

            <Button
              type="primary"
              block
              onClick={openExpense}
              style={{ marginTop: "10px" }}
            >
              Add Expense
            </Button>
          </Card>
        </Col>
      </Row>
    </div>
  );
}